import type { Simplify } from "type-fest";
import type { MaybeRef } from "vue";

import { computedAsync } from "@vueuse/core";
import algoliasearch from "algoliasearch/lite";
import { ref, toValue } from "vue";

import { getEnv } from "@solvari/utils";

type AlgoliaHit = {
  readonly objectID: string;
};

export default function useAlgolia<Return extends Record<string, unknown>>(
  index: string,
  searchValue: MaybeRef<string>,
  facetFilters: MaybeRef<string[]>,
  hitsPerPage: MaybeRef<number> = 5,
) {
  const client = algoliasearch(
    getEnv().integrations.algolia.applicationId,
    getEnv().integrations.algolia.publicSearchApiKey,
  ).initIndex(`${getEnv().integrations.algolia.env}_public_${index}`);

  const loading = ref(false);
  const results = computedAsync(
    async () => {
      const { hits } = await client.search(toValue(searchValue), {
        facetFilters: toValue(facetFilters),
        hitsPerPage: toValue(hitsPerPage),
      });
      return hits as Simplify<AlgoliaHit & Return>[];
    },
    [],
    { evaluating: loading, flush: "post" },
  );

  return { results, loading };
}
